import { Select } from '@cloudflare/kumo/components/select';

// 年度切替用の Select。
export const SUPPORTED_YEARS = [2025, 2026] as const;
export type SupportedYear = (typeof SUPPORTED_YEARS)[number];

interface Props {
  value: SupportedYear;
  onChange: (year: SupportedYear) => void;
}

export default function YearSelector({ value, onChange }: Props) {
  return (
    <Select<string>
      value={String(value)}
      onValueChange={(v) => {
        if (v) onChange(parseInt(v, 10) as SupportedYear);
      }}
      renderValue={(v) => `${v} 年度`}
    >
      {SUPPORTED_YEARS.map((y) => (
        <Select.Option key={y} value={String(y)}>
          {y} 年度
        </Select.Option>
      ))}
    </Select>
  );
}
